import {
  PostalAddressOption,
  TermsAndConditions,
} from 'scenes/common/flows/policyDetails/types';
import {
  AustralianState,
  PaymentFrequency,
  PolicyIssued,
  YesNoAnswer,
} from 'scenes/common/types';
import { IsInsuredSincePossess } from './types';

const defaultAddress = {
  address: '',
  addressLine1: '',
  addressLine2: '',
  postcode: '',
  state: AustralianState.ACT,
  suburb: '',
};

export const defaultPolicyDetails = {
  policyHolders: [],
  businessContactFirstName: '',
  businessContactLastName: '',
  personalContactFirstName: '',
  personalContactLastName: '',
  businessName: '',
  abn: '',
  isBusinessRegisteredForGst: YesNoAnswer.Unspecified,
  isInsuredSincePossessed: IsInsuredSincePossess.Unspecified,
  contactEmailAddress: '',
  contactPhoneNumber: '',
  postalAddressOption: PostalAddressOption.MainAddress,
  overnightAddress: defaultAddress,
  postalAddress: defaultAddress,
  lockedBoxAddress: defaultAddress,
  isRegoKnown: YesNoAnswer.Unspecified,
  missingLicencePlate: '',
  stereoCost: '',
  vehicleModifications: [],
  hasModifications: YesNoAnswer.Unspecified,
  policyIssued: PolicyIssued.Unspecified,
  hasPreExistingDamage: YesNoAnswer.Unspecified,
  hasSpecialFeatures: YesNoAnswer.Unspecified,
  specialFeatures: '',
  specialDetails: [],
  termsAndCondition: TermsAndConditions.Unspecified,
  termsAndConditionForSmallBusiness: TermsAndConditions.Unspecified,
  preselectedPaymentFrequency: PaymentFrequency.Annually,
};
